<template>
  <div class="card">
    <h1 class="card-title">
      {{title}}
      <slot name="header"></slot>
    </h1>

    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    },
    setup(props) {

    }
  }
</script>

<style scoped>

.card {
  overflow: hidden;
  padding: 1rem;
  margin: 1rem;
  border-radius: 10px;
  box-shadow: 2px 3px 10px rgba(0, 0, 0, 0.2);
  background: #fff;
  width: 90vw;
  max-width: 1400px;
}

.card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 400px) {
  .card-title {
    flex-direction: column;
    text-align: center;
  }
}

</style>